import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    supportedMethods: null,
};

const doorKeySlice = createSlice({
    name: 'doorKey',
    initialState,
    reducers: {
        doorKeySupportedMethods: (state, action) =>{
            state.supportedMethods = action.payload;
        },
    },
});

export const { doorKeyRequest, doorKeySupportedMethods } = doorKeySlice.actions;

export default doorKeySlice.reducer;